

const electronicsProducts = [
  {
    id: "01",
    title: "Communication Systems",
    image: "/Communication Systems.jpg",
    description:
      "Advanced communication technologies enabling secure and reliable military communications across operational environments.",
    products: [
      "Tactical Radio Systems",
      "Military Communication Networks",
      "Satellite Communication",
      "Data Link Systems",
      "Secure Voice Communication",
      "Integrated Communication Solutions",
    ],
  },

  {
    id: "02",
    title: "Electronic Warfare Systems",
    image: "/Electronic Warfare Systems.jpg",
    description:
      "Modern electronic warfare capabilities supporting protection, surveillance and operational superiority.",
    products: [
      "Electronic Support Measures",
      "Electronic Countermeasures",
      "Signal Intelligence",
      "Spectrum Monitoring",
      "Threat Detection",
    ],
  },

  {
    id: "03",
    title: "Radar & Surveillance Systems",
    image: "/Radar & Surveillance Systems.jpg",
    description:
      "Integrated radar and surveillance technologies providing enhanced situational awareness.",
    products: [
      "Ground Surveillance Radar",
      "Air Surveillance Radar",
      "Coastal Surveillance",
      "Tracking Systems",
      "Target Acquisition",
    ],
  },

  {
    id: "04",
    title: "Command & Control Systems",
    image: "/Command & Control Systems.jpg",
    description:
      "Command and control solutions designed for operational coordination and mission management.",
    products: [
      "Command Centres",
      "Battle Management Systems",
      "Mission Planning",
      "Control Consoles",
      "Decision Support Systems",
    ],
  },

  {
    id: "05",
    title: "Electro-Optical Systems",
    image: "/Electro-Optical Systems.jpg",
    description:
      "High-performance electro-optical technologies supporting observation, targeting and reconnaissance.",
    products: [
      "Thermal Imaging",
      "Night Vision Systems",
      "Laser Range Finders",
      "Electro-Optical Sensors",
      "Targeting Systems",
    ],
  },

  {
    id: "06",
    title: "Cyber & Information Security",
    image: "/Cyber & Information Security.jpg",
    description:
      "Modern cyber security solutions protecting critical defence communication and information systems.",
    products: [
      "Cyber Defence",
      "Network Security",
      "Encryption Solutions",
      "Information Security",
      "Secure Data Management",
    ],
  },
];

export default electronicsProducts;